
import { createSelector } from '@reduxjs/toolkit';

const NAME = 'transactionTypeRequirement';

export const list = state => state[NAME].list


export const selectedId = state => state[NAME].selected

export const selected = createSelector(
  list,
  selectedId,
  (_list, _selectedId) => Object.values(_list).find(x => +x.attributes.requirement_id === +_selectedId) || {}
)
